import React from "react";
import "../assets/css/Contact.css";

import contactBanner from "../assets/images/contact/contact.jpg";

const ContactHero = () => {
  return (
    <section
      className="contact-hero"
      style={{
        backgroundImage: `url(${contactBanner})`,
      }}
    >
      <div className="container">
        <div >
          <h1 className="contact-title">
            Contact Us
          </h1>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;